import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Label, List, Header, Segment, Button, Icon } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

export default class TrendingSection extends React.Component {
  onViewTrendingClick = listKey => {
    const { history } = this.props

    history.push({
      pathname: `/advertisement/popular/${listKey}/detail`,
      state: { listKey },
    })
  }

  onDeleteTrendingClick = listKey => {
    const conf = window.confirm('Are you sure to remove this popular list?')

    if (conf) {
      firebase
        .database()
        .ref(`/popular_list/${listKey}`)
        .remove()
    }
  }

  renderHeader = () => {
    return (
      <div>
        <Header size="large" style={{ display: 'inline-block' }}>
          Trending
        </Header>
        <Link to="/advertisement/popular/new" style={{ float: 'right' }}>
          <Button icon color="black">
            <Icon name="add" />
          </Button>
        </Link>
      </div>
    )
  }

  renderContent = () => {
    const { popularList } = this.props
    let popularKeys = Object.keys(popularList)
    popularKeys = _.reverse(popularKeys)

    if (_.size(popularList) > 0) {
      const rows = _.map(popularKeys, listKey => {
        const { status } = popularList[listKey]
        const isPublised = status === 'published'

        return (
          <List.Item
            key={listKey}
            style={{ padding: '10px 5px 10px 5px', color: 'black' }}
            active={isPublised}
          >
            <List.Content
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  flexDirection: 'column',
                }}
              >
                <div>
                  <Label size="tiny" color={isPublised ? 'green' : 'red'}>
                    {_.capitalize(status)}
                  </Label>
                </div>
                <div style={{ marginTop: 5 }}>
                  <h4 style={{ fontWeight: 'normal' }}>
                    List created at&nbsp;
                    <span style={{ color: 'darkgray' }}>
                      {moment(parseInt(popularList[listKey].created_at, 10)).format(
                        'DD-MMM-YYYY HH:mm a'
                      )}
                    </span>
                  </h4>
                </div>
              </div>
              <div>
                <Button color="black" onClick={() => this.onViewTrendingClick(listKey)}>
                  View
                </Button>
                <Button color="red" onClick={() => this.onDeleteTrendingClick(listKey)}>
                  Delete
                </Button>
              </div>
            </List.Content>
          </List.Item>
        )
      })

      return (
        <div id="popular-list">
          <List divided verticalAlign="middle">
            {rows}
          </List>
        </div>
      )
    }

    return <div style={{ marginTop: 14 }}>No results</div>
  }

  render() {
    return (
      <Segment color="black">
        <div>
          {this.renderHeader()}
          {this.renderContent()}
        </div>
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/advertisement/components/Trending.js